export const AFFIRMATIONS = [
  "You are stronger than you know, and your community walks beside you.",
  "Small steps forward are still steps forward.",
  "Every dollar saved is a promise kept to your future self.",
  "You are resilient. You have survived every hard day so far.",
  "Asking for help is a sign of strength, not weakness.",
  "Progress, not perfection — that's the goal today.",
  "You belong to a community that cares.",
  "Today, choose one small kindness for yourself.",
  "You are doing better than you think.",
  "Hard times are seasons, not sentences.",
  "Your presence in this community matters.",
  "Rest is productive too.",
  "One good choice today plants a seed for tomorrow.",
  "You are worthy of good things, right now, as you are.",
  "Breathe. This moment is enough.",
  "Community is a mirror — you can see the good in you here.",
  "You have every reason to feel proud of how far you've come.",
  "Tough conversations lead to lighter shoulders.",
  "Gratitude turns what we have into enough.",
  "You are allowed to take up space in this world.",
  "Every small win adds up. Every one.",
  "You bring value that no one else can bring.",
  "This too shall pass — and you'll be stronger on the other side.",
  "Sharing what you know lifts everyone around you.",
  "You are not alone in what you're carrying.",
  "Rest today so you can rise tomorrow.",
  "Your story helps someone else find their own.",
  "Be gentle with yourself — you are trying, and that matters.",
  "The world is kinder because you are in it.",
  "Today is a new page. What will you write on it?",
];

export function getDailyAffirmation() {
  const today = new Date();
  const start = new Date(today.getFullYear(), 0, 0);
  const diff = today - start;
  const day = Math.floor(diff / (1000 * 60 * 60 * 24));
  return AFFIRMATIONS[day % AFFIRMATIONS.length];
}
